import { OrganizationResponseForAdmins } from "client/openapi";
import { Select } from "components/Select";

export function CommunicationFilters({
  organization,
  filterMessagesForStudentIds,
  setFilterMessagesForStudentIds,
  filterMessagesForTutorIds,
  setFilterMessagesForTutorIds,
  filterMessagesForParentIds,
  setFilterMessagesForParentIds,
}: {
  organization: OrganizationResponseForAdmins;
  filterMessagesForStudentIds: number[];
  setFilterMessagesForStudentIds: (val: number[]) => void;
  filterMessagesForTutorIds: number[];
  setFilterMessagesForTutorIds: (val: number[]) => void;
  filterMessagesForParentIds: number[];
  setFilterMessagesForParentIds: (val: number[]) => void;
}) {
  const labelClasses = "mr-2 text-sm font-medium";
  const studentOptions = organization.students.map((student) => ({
    value: student.id,
    label: `${student.first_name} ${student.last_name}`,
  }));

  const tutorOptions = organization.tutors.map((tutor) => ({
    value: tutor.id,
    label: `${tutor.first_name} ${tutor.last_name}`,
  }));

  const parentOptions = organization.parents.map((parent) => ({
    value: parent.id,
    label: `${parent.first_name} ${parent.last_name}`,
  }));

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="flex items-center gap-2">
        <label className={labelClasses}>Search for Students:</label>
        <div>
          <Select
            isMulti
            options={studentOptions}
            value={studentOptions.filter((option) =>
              filterMessagesForStudentIds.includes(option.value)
            )}
            onChange={(selected) =>
              setFilterMessagesForStudentIds(
                selected ? selected.map((option) => option.value) : []
              )
            }
            placeholder="Select students..."
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <label className={labelClasses}>Search for Tutors:</label>
        <div>
          <Select
            isMulti
            options={tutorOptions}
            value={tutorOptions.filter((option) =>
              filterMessagesForTutorIds.includes(option.value)
            )}
            onChange={(selected) =>
              setFilterMessagesForTutorIds(
                selected ? selected.map((option) => option.value) : []
              )
            }
            placeholder="Select tutors..."
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <label className={labelClasses}>Search for Parents:</label>
        <div>
          <Select
            isMulti
            options={parentOptions}
            value={parentOptions.filter((option) =>
              filterMessagesForParentIds.includes(option.value)
            )}
            onChange={(selected) =>
              setFilterMessagesForParentIds(
                selected ? selected.map((option) => option.value) : []
              )
            }
            placeholder="Select parents..."
          />
        </div>
      </div>
    </div>
  );
}
